import { IS_FREE_ACCESS_MODE } from '../../config/freeAccess'

export interface INavigationRoute {
  name: string
  displayName: string
  meta?: { icon?: string; externalUrl?: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'monitor',
      },
    },
    {
      name: 'profit-loss',
      displayName: 'menu.profit-loss',
      meta: {
        icon: 'account_balance',
      },
    },
    {
      name: 'product-report',
      displayName: 'menu.product-report',
      meta: {
        icon: 'inventory_2',
      },
      children: [
        {
          name: 'product-performance',
          displayName: 'menu.product-performance',
        },
        {
          name: 'campaign-attribution',
          displayName: 'menu.campaign-attribution',
        },
      ],
    },
    {
      name: 'orders',
      displayName: 'menu.orders',
      meta: {
        icon: 'receipt_long',
      },
    },
    {
      name: 'customer-ltv',
      displayName: 'menu.customer-ltv',
      meta: {
        icon: 'query_stats',
      },
    },
    {
      name: 'cost-settings',
      displayName: 'menu.cost-settings',
      meta: {
        icon: 'tune',
      },
      children: [
        {
          name: 'product-cost',
          displayName: 'menu.product-cost',
        },
        {
          name: 'shipping-cost',
          displayName: 'menu.shipping-cost',
        },
        {
          name: 'transaction-fee',
          displayName: 'menu.transaction-fee',
        },
        {
          name: 'custom-cost',
          displayName: 'menu.custom-cost',
        },
      ],
    },
    {
      name: 'integrations',
      displayName: 'menu.integrations',
      meta: {
        icon: 'hub',
      },
      children: [
        {
          name: 'marketing-channel',
          displayName: 'menu.marketing-channel',
        },
        {
          name: 'shipping-provider',
          displayName: 'menu.shipping-provider',
        },
        {
          name: 'dropship-pod',
          displayName: 'menu.dropship-pod',
        },
      ],
    },
    {
      name: 'email-reports',
      displayName: 'menu.email-reports',
      meta: {
        icon: 'email',
      },
    },
    ...(IS_FREE_ACCESS_MODE
      ? []
      : [
          {
            name: 'pricing-plans',
            displayName: 'menu.pricing-plans',
            meta: {
              icon: 'credit_card',
            },
          },
        ]),
    // {
    //   name: 'faq',
    //   displayName: 'menu.faq',
    //   meta: {
    //     icon: 'quiz',
    //   },
    // },
    {
      name: 'help',
      displayName: 'menu.support-center',
      meta: {
        icon: 'help_outline',
        externalUrl: 'https://netlyze.io/support',
      },
    },
    // {
    //   name: 'preferences',
    //   displayName: 'menu.preferences',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    // },
    // {
    //   name: 'settings',
    //   displayName: 'menu.settings',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
  ] as INavigationRoute[],
}
